
import { Typography } from "@mui/material";
import { FastField } from "formik";
import React, { useEffect, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { fileToBase64 } from "../../../utils/form";

export const FileUploadInput = ({changeFormikValue, name, multiple, fileTypes, label, hoverTitle,   ...props}) => {
    const [files, setFiles] = useState(null); // still usign state to re-render the component. it wouldn't do it otherwise

    const handleChange = (files) => {
      setFiles(files);
      if(changeFormikValue) changeFormikValue(files);
    };

    const removeFile = (fileName) => {
        if (files?.name) return handleChange(null); // when not in multiple mode

        const fileArray = [...files];
        const newFileArray = fileArray.filter(file => {
            return file?.name !== fileName;
        });

        if (newFileArray.length === 0) return handleChange(null);
        return handleChange(newFileArray);
    }

    const RemoveFileButton = ({fileName}) => {
        return (
            <span
                style={{
                    cursor: 'pointer',
                    color: 'red'
                }}
                onClick={() => removeFile(fileName)}
                title='Suprimer ce ficher'
            >X</span>
        )
    }

    const Typo = ({children}) => {
        return <Typography variant="caption">{children}</Typography>
    }

    const urltoFile = async (url, filename, mimeType) => {
        return (fetch(url)
            .then(function(res){return res.arrayBuffer();})
            .then(function(buf){return new File([buf], filename,{type:mimeType});})
        );
    }

    const fetchData = async() => {
        if (props.fields) {
            let files = [];
            let fields = JSON.parse(props.fields);
            await Promise.all(fields.map(async(field) => {
                var file = await urltoFile(field.content, field.fileName, field.fileTpe);
                files.push(file);
            }));
            if (files.length > 0) {
                if (files.length == 1) {
                    setFiles(files[0]);
                } else {
                    setFiles(files);
                }
            }
        }  
    }

    useEffect(() => {        
        fetchData();              
    }, []);

    return (
        <div>
            <FileUploader
                {...props}
                handleChange={handleChange}
                name={name}
                types={fileTypes}
                label={label}
                hoverTitle={hoverTitle || 'Déposer ici'}
                multiple={multiple}
                fileOrFiles={!!files} //when you add delete functionality => read doc
            />
            <div
                style={{
                    marginTop: "0.5em",
                    paddingLeft: files && multiple ? '20px' : '0'
                }}
            >
                {!files && <Typo>Pas de fichier téléchargé pour l'instant</Typo>}
                {files && !multiple && <Typo> Fichier ajouté : {files?.name} <RemoveFileButton fileName={files?.name} /></Typo>}
                {
                    files && multiple &&
                        <ul>
                            {[...files].map((item, index) => (
                                <li key={index}>
                                    <Typo>{item?.name} <RemoveFileButton fileName={item?.name} /></Typo>
                                </li>
                            ))}
                        </ul>
                }
            </div>
        </div>
    );
}



const FileInput = ({fileTypes, label, base64, hoverTitle, name, multiple, ...props}) => {
    let fileArray = [];

    return (
        <>
        <FastField name={name}>
            {({field, form}) => {
                const changeFormikValue = (files) => {
                    if (!files) {
                        return form.setFieldValue(name, files);
                    }

                    if(!base64) {
                        return form.setFieldValue(name, files);
                    }
                    // if not in multiple mode, the data will not be iterable
                    // we convert accordingly
                    // we check if it is an array
                    files = !files?.length ? [files] : [...files];

                    const callback = (file) => {
                        fileArray.push(file);
                        return form.setFieldValue(name, fileArray);
                    }
                    files.forEach(file => fileToBase64(file, callback))
                }

                return (
                    <FileUploadInput {...{fields: field.value, changeFormikValue, fileTypes, label, hoverTitle, name, multiple, ...props}} />
                );
            }}
        </FastField>
        </>
    );
}
export default FileInput;
